<template>
  <div class="v3-widget v3-panel v3-empty" v-testid="testid">
    <span class="v3-empty-ic"><span class="ms">{{ icon }}</span></span>
    <h3 class="v3-empty-title" v-testid="testid + '-title'">{{ title }}</h3>
    <p v-if="message" class="v3-empty-msg">{{ message }}</p>
    <div v-if="ctaLabel" class="v3-empty-cta">
      <button type="button" class="v3-hero-btn" v-testid="testid + '-cta'" @click="onCta">{{ ctaLabel }}</button>
    </div>
  </div>
</template>

<script>
import { canNavigateTo } from "@/composables/useV3Nav";

// New-portal (v3) EmptyState — a placeable "you're all caught up / nothing needs
// you" panel. Pure presentation (no data); icon + heading + message + optional
// CTA. Persona variants are just different configured copy. Mirrors the beta
// EmptyStateWidget.vue.
export default {
  name: "cLandingV3Empty",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3Empty";
    },
    icon() {
      return this.definition.icon || "task_alt";
    },
    title() {
      return this.definition.title || "You're all caught up";
    },
    message() {
      return this.definition.message || "Nothing needs your attention right now.";
    },
    // CTA is permission-gated (legacy landing-config parity); the editor
    // shows it regardless.
    ctaLabel() {
      const label = this.definition.ctaLabel || "";
      if (!label || this.editMode) return label;
      const action = this.definition.ctaAction || "";
      return !action || canNavigateTo(this, action) ? label : "";
    },
  },
  methods: {
    onCta() {
      if (this.editMode) return;
      const action = this.definition.ctaAction || "";
      if (action === "create") {
        this.$emit("addDocument", "");
        return;
      }
      if (action) this.$router.push({ name: action }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
